import React, { PureComponent } from "react";
import ReactDOM from "react-dom";
import _ from "lodash";
import triggerEvent from "core/customEvent/triggerEvent.js";
import Helper from "helper/index";

import "./imageScrollbar.styl";

class ImageScrollbar extends PureComponent {
  static defaultProps = {
    imageIndex: 0,
    numImages: 0,
    min: 0,
    //HACK : Focus ��忡�� ImageScrollbar ������Ʈ�� ���� �ӽ� ��ġ
    isFocus: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      slideTimeout: 10,
      handleResize: null,
      width: 0,
      height: 0,
    };
  }

  requestId = null;

  componentDidMount() {
    const element = ReactDOM.findDOMNode(this);

    let sliderElement = element.querySelector(".imageSlider");
    const viewport = Helper.DomHelper.closest(
      sliderElement,
      ".viewportContainer"
    )[0];
    this.state.handleResize = _.throttle(() => {
      let sliderElement = element.querySelector(".imageSlider");
      const viewportHeight = viewport.clientHeight;
      sliderElement.style.width = viewportHeight - 20 - 20 + "px";
    }, 150);
    this.state.handleResize();
    window.addEventListener("resize", this.state.handleResize);

    element.querySelector(".scrollbar").addEventListener(
      "rescale",
      function (event) {
        this.state.handleResize();
      }.bind(this)
    );

    element
      .querySelector("input[type=range]")
      .addEventListener("input", this.handleRangeChange.bind(this), true);

    element
      .querySelector("input[type=range]")
      .addEventListener("change", this.handleRangeChange.bind(this), true);

    if (this.container) {
      this.state.width = this.container.offsetWidth;
      this.state.height = this.container.offsetHeight;
    }
    this.setState(this.state);
  }

  componentDidUpdate() {
    this.state.handleResize();
  }

  componentWillUnmount() {
    if (this.state.handleResize) {
      window.removeEventListener("resize", this.state.handleResize);
    }
    const element = ReactDOM.findDOMNode(this);
    let sliderElement = element.querySelector("input[type=range]");
    if (sliderElement !== null && sliderElement !== undefined) {
      sliderElement.removeEventListener("change", this.handleRangeChange);
    }
  }

  handleRangeChange() {
    const element = ReactDOM.findDOMNode(this);
    let sliderElement = element.querySelector(".imageSlider");

    const { slideTimeout } = this.state;
    const newSliderValue = sliderElement.value;

    if (this.requestId !== null) {
      cancelAnimationFrame(this.requestId);
      this.requestId = null;
    }
    this.requestId = requestAnimationFrame(function (timestamp) {
      const viewport = Helper.DomHelper.getSiblings(
        sliderElement.parentNode.parentNode,
        ".imageViewerViewport"
      )[0];
      const newImageIdIndex = parseInt(newSliderValue, 10);
      const data = {
        newImageIndex: newImageIdIndex,
      };
      triggerEvent(viewport, "onChangeScrollbar", data);
    }, slideTimeout);

    return true;
  }

  render() {
    const containerElement = document.getElementsByClassName(
      "viewportContainer"
    )[0];
    //const viewportHeight = viewport.clientHeight;
    //const sliderWidth = viewportHeight - 20;

    let viewportHeight = 0;
    let sliderWidth = 0;

    if (containerElement) {
      viewportHeight = containerElement.clientHeight;
      sliderWidth = viewportHeight - 20 - 20;
    } else {
      viewportHeight = this.state.height;
      sliderWidth = viewportHeight - 20 - 20;
    }
    let value = Math.max(
      Math.min(this.props.imageIndex, this.props.numImages),
      this.props.min
    );
    //const max = this.props.numImages - 1 - this.props.min;
    return (
      <React.Fragment>
        <div className="imageControls" ref={(el) => (this.container = el)}>
          <div className="scrollbar">
            <input
              className="imageSlider"
              type="range"
              //min={0}
              min={this.props.min}
              //min={0}
              //value={this.props.imageIndex}
              value={value}
              onChange={() => {}}
              max={this.props.numImages - 1}
              //max={max}
              step="1"
              style={{ width: sliderWidth + "px" }}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default ImageScrollbar;
